const initialState = {
  students: [],
  type: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SET_ASSIGNMENT_STATE":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
